<style lang="less" scoped>
@import '../../../style/common/variable';
.zlkDetails{position: relative;width: 100%;display: flex;flex-direction: column;justify-content:center;align-items:center;margin: 0;padding: 0;background: #fff;font-family: AlibabaPuHuiTi-Medium;margin-bottom: 20px;}
.national{width: 1200px;}
.searchBar{margin-left: -20px;}
.first{display: flex;justify-content:space-between;width: 1200px;margin:auto;margin-top: 10px;border-top: solid rgb(196, 195, 195);border-width: 1px;}
.second{display: flex;flex-direction: column;width: 810px;margin-right: 40px;}
.third{display: flex;flex-direction: column;width: 350px;}
i{vertical-align: bottom;float: left;margin-left: -5px;margin-right: 5px;font-size: 24px;color: rgb(25, 159, 248);}
.tuijianYD{margin-top: 20px;margin-left: 0px;
  span{font-size: 18px;font-weight: 600;float: left;}
}
.ListYD{margin-left: -34px;margin-top: 0px;text-align: left;}
.hotnews{margin-top: 10px;
  span{font-size: 18px;font-weight: 600;float: left;}
  i{vertical-align: bottom;float: left;margin-left: -5px;margin-right: -2px;font-size: 18px;color: rgb(25, 159, 248);}
}
.hotNewsList{margin-left: -35px;margin-top: 0px;text-align: left;}
.keywords{margin-top: 10px;
  span{font-size: 18px;font-weight: 600;float: left;}
  i{vertical-align: bottom;float: left;margin-left: -5px;margin-right: -2px;font-size: 18px;color: rgb(25, 159, 248);}
}
.keywordsList{margin-left: -34px;margin-top: 0px;text-align: left;}
.sticky{position: sticky; top: 10px;margin: 0px;display: flex;flex-direction: column;justify-content:center;}
@media screen and (max-width: @max-screen){
  .third{display: none;}
}
</style>

<template>
  <div class="zlkDetails">
    <National class="national"></National>
    <Navigation :navigationdatas="navigationList"></Navigation>
    <SearchBar class="searchBar"></SearchBar>
    <div class="first">
      <div class="second">
        <router-view />
      </div>
      <div class="third">
        <div class="tuijianYD">
          <i class="iconfont icon-tubiao303" />
          <span>推荐阅读 / Recommended reading</span>
        </div>
        <List class="ListYD" :List="readingdata" @clickListNews="goDetails"></List>
        
        <div class="sticky">
          <div class="hotnews">
            <i class="iconfont icon-zuirehotchunse" />
            <span>热门篇目 / Hot topics</span>
          </div>
          <HotNewsList class="hotNewsList" :hotNewsList="hotItemdata" @clickHotNews="goDetails"></HotNewsList>
          <div class="keywords">
            <i class="iconfont icon-zuirehotchunse" />
            <span>关键词搜索排行 / Key Word</span>
          </div>
          <KeyWords class="keywordsList" :keywordsList="keywordsdata" @clickKeywords="goKeywords"></KeyWords>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 何宽 资料库列表页、详情页、关键词 公共部分页面
 */
import National from '../assembly/National.vue'
import Navigation from '../assembly/Navigation.vue'
import SearchBar from '../assembly/SearchBar.vue'
import List from '../assembly/List.vue'
import HotNewsList from '../assembly/HotNewsList.vue'
import KeyWords from '../assembly/KeyWords.vue'
import arrayFun  from '../method/array.js'
export default {
  components: {
    National,
    Navigation,
    SearchBar,
    List,
    HotNewsList,
    KeyWords
  },
  name: '',
  data()
  {
    return {
      curID: null,
      catid: null,
      readingdata: [], // 推荐阅读数据
      hotItemdata: [], // 热门篇目数据
      keywordsdata: [], // 关键词搜索排行数据
      navigationList: []  // Navigation组件参数
    }
  },
  created()
  {
    this.getZlkCom()
  },
  methods: {
    getZlkCom()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 24, _exp: 'addtime>0  and examine = 0', orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 20}
      window.post.getPost(paras).then((ret) =>
      {
        this.readingdata = []
        let arrHot = []
        ret[0].data.forEach(item =>
        {
          this.readingdata.push({id: item.id, title: item.title, time: item.addtime})  // 推荐阅读
          arrHot.push({id: item.id, title: item.title, time: item.addtime, hits: item.hits})
        })
        this.hotItemdata = arrHot.sort(arrayFun.compareBtoS('hits'))  // 热门篇目
        let temp = ret[0].data.filter(item =>
        {
          return item.keyword !== ''
        })
        let arrKeywords = []
        temp.forEach(item =>
        {
          if (item.keyword !== '')
            arrKeywords.push({id: item.id, keyword: item.keyword, hits: item.hits, time: item.addtime})
        })
        this.keywordsdata = arrKeywords.sort(arrayFun.compareBtoS('hits'))  // 关键词搜索排行
      })
    },
    // 跳转到矿业资讯列表页面，并将被点击的分类名称提交到vuex
    goList(item)
    {
      let url = this.$router.resolve({path: '/ZlkList', query: {catid: item.catid}})
      window.open(url.href, '_blank')
    },
    // 跳转到矿业资讯详情页面，并将被点击的对象的id提交到vuex
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/ZlkDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    // 跳转到资料库关键词页面，并将被点击的国家信息传递给关键词页面
    goKeywords(item)
    {
      let obj = {keyword: item.keyword, catid: '', sort: '', ssgj: ''}
      let url = this.$router.resolve({path: '/ZlkKeywords', query: obj})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/ZlkCom.vue